<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Débloquer ma ligne</div>
</div>
<div class="row w-100">
    <div class="row w-100 pt-3">
        <div>Vous nous devez <strong>75€</strong>.</div>
    </div>
</div>
<div class="pt-3">
    <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
</div>
